(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-editorial-text';

  function initSection(section) {
    if (section.dataset.odditEditorialReady === 'true') return;
    var triggers = section.querySelectorAll('[data-editorial-tooltip-trigger]');
    if (!triggers.length) return;
    section.dataset.odditEditorialReady = 'true';

    function panelFor(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function close(trigger) {
      var panel = panelFor(trigger);
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.hidden = true;
        panel.style.transform = '';
      }
    }

    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t !== except) close(t);
      });
    }

    function open(trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      reposition(panel);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeAll(trigger);
        if (isOpen) {
          close(trigger);
        } else {
          open(trigger);
        }
      });
    });

    // Click outside / Escape closes any open tooltip.
    document.addEventListener('click', function (event) {
      if (!section.contains(event.target)) closeAll(null);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
    window.addEventListener('resize', function () {
      closeAll(null);
    });
  }

  function reposition(panel) {
    panel.style.transform = '';
    var rect = panel.getBoundingClientRect();
    var margin = 8;
    var shift = 0;
    if (rect.right > window.innerWidth - margin) {
      shift = window.innerWidth - margin - rect.right;
    } else if (rect.left < margin) {
      shift = margin - rect.left;
    }
    if (shift) {
      panel.style.transform = 'translateX(' + Math.round(shift) + 'px)';
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
